import { TextField, Button, Grid, Typography, Box } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import theme from './Theme';

interface ImageUploadProps {
  images: string[];
  onChange: (images: string[]) => void;
}

export const ImageUpload = ({ images, onChange }: ImageUploadProps) => {
  const handleImageChange = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const updatedImages = [...images];
    updatedImages[index] = value;
    onChange(updatedImages);
  };

  const handleRemoveImage = (index: number) => {
    const updatedImages = images.filter((_, i) => i !== index);
    onChange(updatedImages);
  };

  const handleAddNewImageRow = () => {
    onChange([...images, '']);
  };

  return (
    <>
      <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <ImageIcon sx={{ color: theme.palette.accent.main }} />
        Images
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Please paste a link of the image. Image upload will be released in the future
      </Typography>
      {images.map((imageUrl, index) => (
        <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
          <Grid item xs={9}>
            <TextField
              label={`Image URL ${index + 1}`}
              fullWidth
              value={imageUrl}
              onChange={handleImageChange(index)}
            />
          </Grid>
          <Grid item xs={3}>
            <Button 
              variant="outlined" 
              color="error" 
              onClick={() => handleRemoveImage(index)}
            >
              Remove
            </Button>
          </Grid>
        </Grid>
      ))}
      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleAddNewImageRow}
      >
        Add New
      </Button>
    </>
  );
};
